// extracted by mini-css-extract-plugin
export default {"wrap":"DeviceStatus_wrap__+lEwD","text":"DeviceStatus_text__rkGq0","status":"DeviceStatus_status__oxoax","subtitle":"DeviceStatus_subtitle__ssEHR","meta":"DeviceStatus_meta__kMzoM"};